import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PropTypes from 'prop-types';
import React from 'react';
import {
  AccordionDetails,
  Accordion as MuiAccordion,
  AccordionSummary as MuiAccordionSummary,
  Typography,
} from '@mui/material';

const AccordionSummary = props => (
  <MuiAccordionSummary
    {...props}
    expandIcon={<ExpandMoreIcon color="inherit" />}
    sx={{
      backgroundColor: 'primary.dark',
      backgroundImage: theme => theme.vars?.overlays[2],
      borderBottom: 'solid 1px',
      borderBottomColor: 'divider', // borderBlockEndColor doesn't work here, fyi
      color: 'white',
      flexDirection: 'row-reverse',
      gap: 1,
      minHeight: 36,
      paddingInlineStart: 1, // Special offset so the chevron looks right
      paddingInlineEnd: 1.5,
      '.MuiAccordionSummary-expandIconWrapper': {
        color: 'inherit',
      },
      // eslint-disable-next-line react/prop-types
      ...props.sx,
    }}
  />
);

const Accordion = ({title, children, defaultExpanded = true, ...props}) => {
  return (
    <MuiAccordion defaultExpanded={defaultExpanded} {...props}>
      <AccordionSummary>
        <Typography>{title}</Typography>
      </AccordionSummary>
      <AccordionDetails>{children}</AccordionDetails>
    </MuiAccordion>
  );
};

Accordion.propTypes = {
  title: PropTypes.string.isRequired,
  defaultExpanded: PropTypes.bool,
  children: PropTypes.node,
};

export default Accordion;
